// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { chargeSchema } from '@/billing/api/types';
import { z } from 'zod';

const getProjectLineItemChargesResponseSchema = z.object({
  data: z
    .array(chargeSchema)
    .nullable()
    .transform((v) => v ?? []),
  metadata: responseMetadataSchema,
});

type GetProjectLineItemChargesResponse = z.infer<
  typeof getProjectLineItemChargesResponseSchema
>;

export async function getProjectLineItemCharges(
  projectKey: string,
  lineItemKey: string
): Promise<GetProjectLineItemChargesResponse> {
  const url = `/v1/project/${projectKey}/line-item/${lineItemKey}/charges`;
  const response = await api.get(url);
  return parseResponse(getProjectLineItemChargesResponseSchema, response.data, {
    schemaName: 'ProjectLineItemCharges',
    endpoint: url,
  });
}
